import {
  VTextField,
  VTextarea,
  VSelect,
  VAutocomplete,
} from 'vuetify/components';

import DynamicJsonField from '@/components/form/DynamicJsonField.vue'
import FileUploader from '@/components/form/FileUploader.vue';
import LeadDetail from '@/components/modules/opportunities/Detail.vue'
import DatePickerInput from '@/components/form/DatePickerInput.vue';

import type { FormField } from '@/types/form';

export const CREATE_FORM: FormField[] = [  
  { value: 'user_id', 
    permission_state:'hidden',
    permission:'activities.assign',
    label: 'Vendedor', 
    component: VAutocomplete, 
    required: false, 
    col: 6, 
    fetchOptions: 'searchUsers', 
    searchValue: 'name', 
    itemText: (item: any) => [item?.name, item?.last_name].filter(Boolean).join(' ') || '', 
    itemValue: 'id',
    fetchParams: () => ({
      'filter[is_active]': 1
    }),
  },
  { value: 'status', label: 'Status', component: VAutocomplete, required: false, col: 6, fetchOptions: 'searchOpportunityStatuses', searchValue: 'name', itemText: 'name', itemValue: 'name'},
  { value: 'opportunity_name', label: 'Nombre', component: VTextField, required: false, col: 12 },
  { value: 'subject', 
    label: 'Cliente/Lead', 
    component: VAutocomplete, 
    searchValue: 'name',
    required: true, 
    col: 6, 
    mdcol:12, 
    fetchOptions: 'searchClientsAndLeads', 
    itemText: (item: any) => item?.attributes?.commercial_name || item?.attributes?.legal_name || item?.attributes?.name || '', 
    itemValue: (item: any) => item,
    transform: (value: any) => ({
      subject_id: value?.id ?? value,
      subject_type: value?.type,
    })
  },
  { value: 'date', label: 'Fecha de Publicación', component: DatePickerInput, required: false, col: 6, range: false },
  {
    value: 'description',
    label: 'Notas',
    component: VTextarea,
  }
];

const idFieldMappings: Record<string, { relatedKey: string, property?: string }> = {
  user_id: { relatedKey: 'user', property: 'id' },
  status: { relatedKey: 'current_status', property: 'name' }
};

export const EDIT_FORM: FormField[] = [...CREATE_FORM.map(field => {
  const mapping = idFieldMappings[field.value];
    if (mapping) {
      return {
        ...field,
        parse: (_: any, item: any) =>
          mapping.property
            ? (item[mapping.relatedKey]?.[mapping.property] !== undefined
                ? item[mapping.relatedKey]
                : null)
            : item[mapping.relatedKey] || null,
        transform: (val: any) => ({
          [field.value]:
            mapping.property
              ? (typeof val === 'object' && val !== null
                  ? val[mapping.property]
                  : val)
              : (val?.id ?? val)
        })
      };
    }
    return field;
})];

export const HEADERS = [
  { title: '', value: 'eye_detail', format: 'text', sortable: false },
  { title: 'ID', value: 'id', format: 'text', sortable: true },
  { title: 'Nombre', value: 'opportunity_name', format: 'text', sortable: true },
  { title: 'Fase', value: 'current_status.name', format: 'text', sortable: false },
  { title: 'Valor', value: 'amount', format: 'text', sortable: true },
  { title: 'Fecha', value: 'date', format: 'text', sortable: true },
  { title: 'Descripción', value: 'description', format: 'text', sortable: true },
  { title: 'Cliente/Lead', value: 'subject', format: 'text', sortable: true },
  { title: 'Vendedor', value: 'user', format: 'text', sortable: true },
];

export const DEFAULT_HEADER_ORDER = [
  'eye_detail',
  'id',
  'opportunity_name',
  'current_status.name',
  'amount',
  'date',
  'description',
  'subject',
  'user',
];

export const DETAIL = {
  expand_table: false,
  eye_detail: true,
  key: 'all',
  component: LeadDetail
};

export const FILTERS = [  
  { value: 'user_id', label: 'Vendedor', component: VAutocomplete, fetchOptions: 'searchUsers', 
    searchValue: 'name',
    itemText: (item: any) => [item?.name, item?.last_name].filter(Boolean).join(' ') || '',
    itemValue: (item: any) => item,
    transform: (values: any) => ({
      user_id: Array.isArray(values)
      ?values.map(v=>v.id??v).join(',')
      :values?.id ?? values
    }),
    multiple:true
  },
  //{ value: 'status', label: 'Status', component: VAutocomplete, fetchOptions: 'searchOpportunityStatuses', itemText: 'name', itemValue: 'name' },
  { value: 'opportunity_name', label: 'Nombre', component: VTextField },
  { value: 'subject_id', 
    label: 'Cliente/Lead', 
    component: VAutocomplete, 
    fetchOptions: 'searchClientsAndLeads', 
    searchValue: 'name',
    itemText: (item: any) => item?.attributes?.commercial_name || item?.attributes?.legal_name || item?.attributes?.name || '', 
    itemValue: (item: any) => item,
    transform: (value: any) => ({
      subject_id: value?.id ?? value,
      subject: value?.type
    })
  },
  { value: 'date_between', label: 'Fecha de Publicación', component: DatePickerInput, range: true },
  { value: 'created_between', label: 'Fecha de Creación', component: DatePickerInput, range: true },
  {
    value: 'description',
    label: 'Notas',
    component: VTextField,
  }
];

export const KANBAN = {
  statusField: 'status',
  confirmForm: true,
  changeFormFields: [
    {
      value: 'status_comment',
      label: 'Comentario',
      component: VTextarea,
      required: true,
      col: 12,
    },
    {
      value: 'additional_data',
      label: 'Documentos',
      isJsonArray: true,
      plainJson: false,
      component: DynamicJsonField,
      col: 12,
      children: [
        {
          value: 'label',
          label: 'Etiqueta',
          component: VTextField,
          col: 6,
        },
        {
          value: 'file',
          label: 'Archivo',
          component: FileUploader,
          module: 'activities', // importante
          col: 6,
          required: false,
          multiple: true,
        }
      ],
    },
  ],
};
